import { IReducerFn } from '../type';
import { StepsState } from './riskMotorFlow.type';

export const stepsReducer: IReducerFn<StepsState> = (
  state,
  { type, payload }
) => {
  switch (type) {
    case 'update_step':
      return {
        ...state,
        currentStep: payload.currentStep,
      };
    case 'set_requesterInformation':
      return {
        ...state,
        requesterInformation: payload.requesterInformation,
      };
    case 'set_steps_config':
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

stepsReducer.key = 'steps';
stepsReducer.initialState = {
  currentStep: 0,
  stepsQuantity: 0,
  requesterInformation: {
    socialEnterpriseName: undefined,
    enterpriseCnpj: undefined,
    responsibleName: undefined,
    responsiblePhone: undefined,
  },
};
